import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import CustomNavbarClients from "../navBarClients/CustomNavbarClients";
import ClientMenuBar from "../ClientMenuBar";
import Footer from "../Footer";
import logo from "assets/logo.png";
import { useBreakpoints } from "hooks/useBreakPoints";
import "./AboutUs.scss";

const AboutUs: React.FC = () => {
  const { isMobile, isTablet } = useBreakpoints();

  return (
    <>
      <CustomNavbarClients />
      <ClientMenuBar />

      <Container fluid className="about-us-container">
        <Row className="justify-content-center">
          <Col xs={12} md={10} lg={8} xl={6}>
            <div className="about-content">
              {/* Title */}
              <div className="title-section">
                <h1 className="main-title">Nallely Boutique</h1>
                <div className="title-divider"></div>
              </div>

              {/* Logo */}
              <div className="logo-section">
                <img
                  src={logo}
                  alt="Logo Nallely Boutique"
                  className="about-logo"
                />
              </div>

              {/* Welcome Text */}
              <div className="welcome-section">
                <h2 className="welcome-title">
                  Bienvenidos a Nallely Boutique
                </h2>

                <div className="description-text">
                  <p>
                    Tu tienda de moda online y física ubicada en{" "}
                    <strong>
                      Av Marte R. Gómez 403, Francisco I. Madero, 87395 Heroica
                      Matamoros, Tamps.
                    </strong>
                    Nos especializamos en ofrecer ropa de alta calidad para
                    todas las personas, pensada para cada ocasión.
                  </p>

                  <p>
                    Nuestro objetivo es brindarte una experiencia de compra
                    única, combinando las últimas tendencias con un excelente
                    servicio.
                  </p>

                  <p>
                    Ofrecemos <strong>envíos a todo México</strong>, asegurando
                    que recibas tus productos con la mejor calidad y en el menor
                    tiempo posible. Además, nuestra tienda física en Matamoros
                    es el lugar perfecto para que nos visites, pruebes nuestros
                    productos y disfrutes de un servicio personalizado.
                  </p>

                  <p className="final-message">
                    <strong>
                      Gracias por confiar en nosotros, ¡esperamos que disfrutes
                      de tu compra!
                    </strong>
                  </p>
                </div>
              </div>

              {/* Additional Info Cards */}
              <div className="info-cards">
                <Row>
                  <Col xs={12} md={4} className="mb-4">
                    <div className="info-card">
                      <h4>Tienda Física</h4>
                      <p>
                        <strong>Av Marte R. Gómez 403</strong>
                        <br />
                        Francisco I. Madero
                        <br />
                        87395 Heroica Matamoros, Tamps.
                      </p>
                    </div>
                  </Col>
                  <Col xs={12} md={4} className="mb-4">
                    <div className="info-card">
                      <h4>Envíos Nacionales</h4>
                      <p>Enviamos a toda la República Mexicana</p>
                    </div>
                  </Col>
                  <Col xs={12} md={4} className="mb-4">
                    <div className="info-card">
                      <h4>Alta Calidad</h4>
                      <p>Ropa pensada para cada ocasión</p>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </Col>
        </Row>
      </Container>

      <Footer />
    </>
  );
};

export default AboutUs;
